module.exports = __webpack_public_path__ + "img/converifai-logo-dark-mini.bd6e2a11.svg";